function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#EAF3FF"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 27.6155,
  y: 11,
  width: 1.95814,
  height: 23.4977,
  transform: "rotate(45 27.6155 11)",
  fill: "#373737"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M17.8039 15.8962C17.8039 16.9661 16.9365 17.8334 15.8667 17.8334C14.7968 17.8334 13.9294 16.9661 13.9294 15.8962C13.9294 14.8263 14.7968 13.959 15.8667 13.959C16.9365 13.959 17.8039 14.8263 17.8039 15.8962Z",
  stroke: "#373737",
  strokeWidth: 2
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M25.6364 24.7067C25.6364 25.7766 24.7691 26.644 23.6992 26.644C22.6293 26.644 21.762 25.7766 21.762 24.7067C21.762 23.6369 22.6293 22.7695 23.6992 22.7695C24.7691 22.7695 25.6364 23.6369 25.6364 24.7067Z",
  stroke: "#373737",
  strokeWidth: 2
});

function SvgServiceFee(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceFee);
export default __webpack_public_path__ + "static/media/service_fee.e7ca2c24.svg";
export { ForwardRef as ReactComponent };